import { lang } from "@umu/ukit-lang";

const defaultPlaceholder:[string, string] = [lang('开始时间'), lang('结束时间')];// 日期选择器默认提示
const defaultMaxWidth = '7rem';// 日期选择器默认最大宽度
const defaultDateFormat = 'YYYY-MM-DD';// 日期选择器默认日期格式

export {
    defaultDateFormat,
    defaultMaxWidth,
    defaultPlaceholder
}